import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { CookiesProvider } from 'react-cookie';
import App from './App';
import SparkThemeProvider from 'components/Providers/ThemeProvider';
import AuthWrapper from 'components/Providers/AuthWrapper';
import reportWebVitals from './reportWebVitals';
import './index.css';
import { CACHE_AND_STALE_TIME } from './constants';

export const client = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      ...CACHE_AND_STALE_TIME,
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <CookiesProvider>
        <QueryClientProvider client={client}>
          <AuthWrapper>
            <ReactQueryDevtools initialIsOpen={false} position='bottom-right' />
            <SparkThemeProvider>
              <App />
            </SparkThemeProvider>
          </AuthWrapper>
        </QueryClientProvider>
      </CookiesProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
